export default __webpack_public_path__ + "static/media/uefa24-prediction-cn.da56f78f.webp";